import { apiInstance } from "../apiInstance";

export const postUpdateFixturesJob = async (payload) => {
	const res = await apiInstance.post("jobs/updatefixtures", payload);
	return res;
};

export const postUpdateScoresJob = async (payload) => {
	const res = await apiInstance.post("jobs/updatescores", payload);
	return res;
};